import React from "react";
import { useParams, Link } from "react-router-dom";

import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";
import { underConstructionContent } from "../data/underConstructionContent.ts";
import { useCurrentLang } from "../hooks/useCurrentLang.js";

import "../styles/globals.css";
import "../styles/layout.css";



export const UnderConstructionPage = ({lang="en"}) => {
  const currentLang = useCurrentLang()
  const t = underConstructionContent[currentLang]

 
  return (
    <div className="main-layout not-found-page">
      <Header lang={currentLang} />

      <main className="not-found-main">
        <div className="glass-card not-found-card">
          <h1 className="not-found-title" style={{color: "white"}}>{t.title}</h1>
          <p className="not-found-text" style={{color: "var(--text-muted)"}}>{t.text}</p>

          <p className="not-found-hint" style={{color: "var(--text-muted)"}}>
            {t.hint}
          </p>
        </div>
      </main>

      <Footer lang={currentLang} />
    </div>
  );
};

export default UnderConstructionPage;
